"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSecureDomain = exports.isInIframe = void 0;
/**
 * returns true if the current window is not window.self.
 */
function isInIframe() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
exports.isInIframe = isInIframe;
/**
 * returns true if the current protocol is https.
 */
function isSecureDomain() {
    var _a;
    return ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) !== 'http:';
}
exports.isSecureDomain = isSecureDomain;
//# sourceMappingURL=StorageUtils.js.map